import React, { FC, PropsWithChildren } from 'react';

import { Stack, StackProps } from 'Modules/ui3';


export interface CellContainerProps extends Pick<StackProps, 'justifyContent'> {
    columnWidth: string;
}

export const CellContainer: FC<PropsWithChildren<CellContainerProps>> = ({
    children, columnWidth, ...props
}) => (
    <Stack
        flex={`1 0 ${columnWidth}`}
        direction='row'
        alignItems='flex-start'
        overflow='hidden'
        sx={{
            whiteSpace: 'nowrap',
            '& *': {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
        }}
        {...props}
    >
        {children}
    </Stack>
);
